module.exports = __webpack_public_path__ + "static/media/Logo.219c1dce.png";